import { h } from 'preact';

const getSizedImageUrl = (src, size, isTransformed) => {
  if (size === null) return src;
  const match = src.match(
    /\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i,
  );
  if (!match) return null;
  const prefix = src.split(match[0]);
  const suffix = match[0];
  if (isTransformed) {
    return `${prefix[0].replace('600x600', `${size}x`)}${suffix}`.replace(
      /http(s)?:/,
      '',
    );
  }
  return `${prefix[0]}_${size}x${suffix}`.replace(/http(s)?:/, '');
};

const Image = ({
  alt,
  onLoad,
  src,
  isTransformed,
  srcWidths = {},
  height,
  width,
  additionalClasses = '',
  nodeRef,
}) => {
  const bps = { sm: 640, md: 768, lg: 1024, xl: 1280, '2xl': 1536 };

  // Remove undefined breakpoints
  Object.keys(bps).forEach((key) => !srcWidths[key] ?? delete bps[key]);
  Object.keys(srcWidths).forEach((key) => !bps[key] ?? delete srcWidths[key]);

  // Reduce to values arrays
  const srcWidthsReduced = Object.values(srcWidths);
  const sizeWidthsReduced = Object.values(bps);

  // Convert to srcset and sizes values
  const srcsetFormatted =
    srcWidthsReduced &&
    srcWidthsReduced
      .map((w) => `${getSizedImageUrl(src, w, isTransformed)} ${w}w`)
      .join(',');
  const sizesFormatted =
    srcWidthsReduced &&
    srcWidthsReduced
      .map((w, i) => `(max-width: ${sizeWidthsReduced[i]}px) ${w}px`)
      .slice(0, srcWidthsReduced.length - 1)
      .join(',') + `, ${srcWidthsReduced[srcWidthsReduced.length - 1]}px`;

  return (
    <img
      className={`image ${additionalClasses}`}
      srcset={srcsetFormatted}
      sizes={sizesFormatted}
      src={src}
      alt={alt}
      height={height}
      width={width}
      ref={nodeRef}
      onLoad={onLoad}
    />
  );
};

export default Image;
